<div class="modal">
  <div class="modal-ctn">

    <div class="options">
      <div>{{ 'CONTAINER.NEW' | translate }}</div>
      <button type="button" class="icon-action" title="Close" (click)="close()"><ng-icon name="heroXMark" size="20"/></button>
    </div>

    <form [formGroup]="form" class="form-grid">

      <div>
        <label>{{ 'PRODUCT.CONTAINER' | translate }} ID</label>
        <df-input block formControlName="containerId" />
      </div>
      <div>
        <label>{{ 'CONTAINER.PRESSURE' | translate }} ({{ market.pressureUom }})</label>
        <df-input block formControlName="containerMAWP" />
      </div>
      <div>
        <label>{{ 'CONTAINER.CAPACITY' | translate }} ({{ market.volumeUom }})</label>
        <df-input block formControlName="containerMaxCapacity" />
      </div>
      <div>
        <label>{{ 'CONTAINER.EMPTY_TARE' | translate }} ({{ market.weightUom }})</label>
        <df-input block formControlName="containerTareWeight" />
      </div>
      <div>
        <label>{{ 'CONTAINER.MODEL_NAME' | translate }}</label>
        <df-select formControlName="containermodelName"
          [options]="containerModels | selectOptions:'containermodelName'" />
      </div>
      <div>
        <label>{{ 'CONTAINER.TRANSPORT_COMPANY' | translate }}</label>
        <df-select formControlName="transportcompanyName"
          [options]="transportCompanies | selectOptions:'transportcompanyName'" />
      </div>
      <div>
        <label>{{ 'CONTAINER.PUMP_CARRIER' | translate }}</label>
        <input type="checkbox" formControlName="containerPumpCarrier"/>
      </div>

    </form>

    <div class="footer">
      <df-button variant="primary" (onClick)="create()" [disabled]="form.invalid">{{ 'CREATE' | translate }}</df-button>
    </div>

  </div>
</div>